export default "__VITE_ASSET__02wNhhT4__"